import { Route, Routes, Navigate } from 'react-router'
import DevToolsLayout from './DevToolsLayout/DevToolsLayout'
import ContactsPage from './Contacts/ContactsPage'
import PodUpdaterPage from '@/containers/DevToolsNew/PodUpdater/PodUpdaterPage'
import CommandsPage from '@/containers/DevToolsNew/Commands/CommandsPage'
import CommunicationBoardPage from '@/containers/DevToolsNew/CommunicationBoard/CommunicationBoardPage'
import CachePage from '@/containers/DevToolsNew/Cache/CachePage'
import SalesScriptPage from '@/containers/DevToolsNew/SalesScript/SalesScriptPage'

const BASE_PATH = '/dev-tools-v2'
const DevToolsNew = () => {
  return (
    <DevToolsLayout>
      <Routes>
        <Route index element={<Navigate to={`${BASE_PATH}/contacts`} replace />} />
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="pod-updater" element={<PodUpdaterPage />} />
        <Route path="commands" element={<CommandsPage />} />
        <Route path="cache" element={<CachePage />} />
        <Route path="communication" element={<CommunicationBoardPage />} />
        <Route path="sales-script" element={<SalesScriptPage />} />
        <Route path="*" element={<Navigate to={`${BASE_PATH}/contacts`} replace />} />
      </Routes>
    </DevToolsLayout>
  )
}

export default DevToolsNew
